import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#292D32",
      d: "M9.75 6.75c.14 0 .25.11.25.25v.5C10 8.33 9.33 9 8.5 9c0-.825-.675-1.5-1.5-1.5S5.5 8.175 5.5 9h-1c0-.825-.675-1.5-1.5-1.5S1.5 8.175 1.5 9C.67 9 0 8.33 0 7.5v-1c0-.275.225-.5.5-.5h4.75c.69 0 1.25-.56 1.25-1.25V2c0-.275.225-.5.5-.5h.42c.36 0 .69.195.87.505l.32.56a.126.126 0 0 1-.11.185c-.69 0-1.25.56-1.25 1.25v1.5c0 .69.56 1.25 1.25 1.25z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#292D32",
      d: "M3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2M10 5.265V6H8.5a.5.5 0 0 1-.5-.5V4c0-.275.225-.5.5-.5h.645l.725 1.27c.085.15.13.32.13.495M5.54 0H1.845C.825 0 0 .825 0 1.845v3.19c0 .275.225.5.5.5h4.575c.51 0 .925-.415.925-.925V.46A.46.46 0 0 0 5.54 0M4.035 2.535 2.99 3.545a.38.38 0 0 1-.26.105.37.37 0 0 1-.26-.105l-.505-.48a.377.377 0 0 1 .52-.545l.245.235.785-.76a.373.373 0 0 1 .53.01c.145.15.14.385-.01.53"
    }, null, -1)
  ])))
}
export default { render: render }